import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    flex: 1,
  },
  animatedViewStyle: {
    marginTop: 0,
  },
  scollViewContainer: {
    paddingBottom: 300,
  },
  statusText: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 20.8,
    lineHeight: 30,
    marginBottom: 32,
  },
});
